import { cn } from "@/lib/utils";

/** Vertical gap between major blocks on app pages (header, sections, list chrome). */
export const PAGE_STACK_GAP_CLASS = "gap-4";

/**
 * Content inset for all post-login routes — applied on {@link PageScrollViewport} inner wrapper.
 * Desktop: symmetric 32px on all sides at `lg+`. Mobile: bottom clears the floating bottom nav.
 */
export const pageContentPaddingClassName = cn(
  "px-4 pt-4 pb-4 sm:px-6 sm:pt-6 sm:pb-6 lg:px-8 lg:pt-8 lg:pb-8",
  "max-lg:pb-[calc(3.25rem+1rem+8px+max(0.75rem,env(safe-area-inset-bottom)))]",
);

/** No extra right pad when the help dock’s own 12px margin is the gutter. */
export const pageContentPaddingHelpDockedClassName = "lg:pr-0";

/** Root stack for top-level pages (e.g. /projects). */
export const pageStackClassName = cn(
  "flex flex-col",
  "max-lg:flex-none",
  "lg:min-h-0 lg:flex-1",
  PAGE_STACK_GAP_CLASS,
);

/** Outer shell pages (project/settings/account) — chrome only. */
export const pageSecondaryStackClassName = cn(
  "flex min-w-0 flex-col",
  "max-lg:flex-none",
  PAGE_STACK_GAP_CLASS,
);

/** Nested content pages inside a shell — no flex-1. */
export const pageNestedStackClassName = cn("flex min-w-0 flex-col", PAGE_STACK_GAP_CLASS);

/** Loading skeleton inside a {@link Page} — gap only. */
export const pageInnerStackClassName = cn("flex flex-col", PAGE_STACK_GAP_CLASS);
